import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const AdminApi = createApi({
  reducerPath: "AdminApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["ADMINAPI"],
  endpoints: (build) => ({
    getAdmin: build.query({
      query: ({ page }) => ({
        url: `/admin?page=${page}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["ADMINAPI"],
    }),

    getAdminById: build.query({
      query: ({ id }) => ({
        url: `/admin/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["ADMINAPI"],
    }),

    editAdmin: build.mutation({
      query: ({ id, data }) => ({
        url: `/admin/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["ADMINAPI"],
    }),

    addAdmin: build.mutation({
      query: ({ data }) => ({
        url: `/admin/register`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["ADMINAPI"],
    }),
    verifyRegistration: build.mutation({
      query: ({ data }) => ({
        url: `/admin/register/verify-otp`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["ADMINAPI"],
    }),

    deleteAdmin: build.mutation({
      query: ({ id }) => ({
        url: `/admin/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["ADMINAPI"],
    }),
  }),
});

export const {
  useGetAdminQuery,
  useGetAdminByIdQuery,
  useEditAdminMutation,
  useAddAdminMutation,
  useDeleteAdminMutation,
  useVerifyRegistrationMutation
} = AdminApi;
